<div class="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Sign up for an account
        </h2>
      </div>
      <form class="max-w-md mx-auto mt-8 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="firstName">
            First Name
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="firstName"
            type="text"
            placeholder="First Name"
            formControlName="firstName"
            autocomplete="given-name"
          />
          @if ((f.firstName.touched || submitted)  && (f.firstName.hasError('required') || f.firstName.hasError('whitespace'))) {
            <span class="text-xs text-red-400 m-0 p-0">First Name is <strong>required</strong></span>
          }
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="lastName">
            Last Name
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="lastName"
            type="text"
            placeholder="Last Name"
            formControlName="lastName"
            autocomplete="family-name"
          />
          @if ((f.lastName.touched || submitted)  && (f.lastName.hasError('required') || f.lastName.hasError('whitespace'))) {
            <span class="text-xs text-red-400 m-0 p-0">Last Name is <strong>required</strong></span>
          }
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="schoolName">
            School Name
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="schoolName"
            type="text"
            placeholder="School Name"
            formControlName="schoolName"
          />
          @if ((f.schoolName.touched || submitted)  && (f.schoolName.hasError('required') || f.schoolName.hasError('whitespace'))) {
            <span class="text-xs text-red-400 m-0 p-0">School Name is <strong>required</strong></span>
          }
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
            Email
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="email"
            type="email"
            placeholder="Email"
            formControlName="email"
            autocomplete="email"
          />
          @if ((f.email.touched || submitted)  && (f.email.hasError('required') || f.email.hasError('whitespace'))) {
            <span class="text-xs text-red-400 m-0 p-0">Email is <strong>required</strong></span>
          }
          @if ((f.email.touched || submitted)  && f.email.hasError('email')) {
            <span class="text-xs text-red-400 m-0 p-0">Please Enter A Valid Email</span>
          }
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
            Password
          </label>
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="password"
            type="password"
            name="password"
            placeholder="Password"
            formControlName="password"
            autocomplete="new-password"
            required
          />
          @if ((f.password.touched || submitted)  && (f.password.hasError('required') || f.password.hasError('whitespace'))) {
            <span class="text-xs text-red-400 m-0 p-0">Password is <strong>required</strong></span>
          }
        </div>
        <div class="py-2">
            <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm rounded-md text-white bg-[#E31C79] hover:bg-rose-700 font-normal focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              Sign up
            </button>
        </div>
        <div class="text-center py-2">
            <p class="text-sm text-gray-600">
              Already have an account? 
              <button class=" text-sm text-indigo-500 font-normal focus:outline-none" routerLink='/' >
                Sign In
              </button>
            </p>
        </div>
        <p class="text-center text-gray-500 text-xs">
          &copy;2024 Techo2. All rights reserved.
        </p>
      </form>
    </div>
</div>